import { useState } from "react";
import { Sun, Moon } from "lucide-react";
import { getThemeMode, setThemeMode } from "@/context/ThemeProvider";

export function ThemeToggle() {
  const [mode, setMode] = useState(getThemeMode());
  const toggle = () => {
    const next = mode === "dark" ? "light" : "dark";
    setThemeMode(next);
    setMode(next);
  };
  return (
    <button
      data-testid="theme-toggle"
      onClick={toggle}
      aria-label="Toggle dark mode"
      className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-tenant-border bg-tenant-surface text-muted-foreground transition-all duration-300 ease-spring hover:-translate-y-0.5 hover:text-foreground active:scale-90"
    >
      {mode === "dark" ? <Sun className="h-[18px] w-[18px]" /> : <Moon className="h-[18px] w-[18px]" />}
    </button>
  );
}
